import { RadioButtonGroup } from 'framework/form';
import type { CreateEditFormSection } from 'framework/ViewTypes/contentLayout';

const FULL_WIDTH = { xs: 12, md: 12, xl: 12 };

const fieldSx = {
  '& .floating-label-input, & .form-group': { mb: 0 },
};

export const getReviewPositionFillRequestSections = (): CreateEditFormSection[] => [
  {
    id: 'decision',
    fields: [
      {
        id: 'decisionType',
        size: FULL_WIDTH,
        sx: fieldSx,
        content: (
          <RadioButtonGroup
            source="decision"
            label=""
            options={[
              { value: 'APPROVE', label: 'Approve' },
              { value: 'REJECT', label: 'Reject' },
            ]}
            sx={{
              '& .MuiFormControlLabel-root': {
                marginLeft: 0,
              },
            }}
            isRequired
          />
        ),
      },
    ],
  },
];
